import styled from 'styled-components';
import StackLayoutImplementation from './implementation/StackLayoutImplementation';
var StackLayoutComponent = styled(StackLayoutImplementation)(function (props) {
    var styleObject = props.theme.layoutThemes.stackLayout.getStyleObjectBuilder(props, 'flex', 'margin', 'padding', 'border', 'backgroundColor', 'height', 'width', 'zIndex', 'position', 'circle', 'opacity', 'overflow')
        .withBaseStyle({
        display: 'flex'
    })
        .withWebStyle({
        position: 'relative'
    })
        .withWebStyle({
        cursor: 'pointer'
    }, !props.onPress)
        .withCustomStyle(props.customStyle)
        .build();
    return styleObject;
});
export default StackLayoutComponent;
//# sourceMappingURL=StackLayoutComponent.js.map